<script setup>
  import { ref, onMounted, useTemplateRef } from 'vue';
  import { useResizeObserver } from '@vueuse/core';
  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    }
  })

  const subheadElement = useTemplateRef('subhead-element');
  const textElement = useTemplateRef('text-element');

  const showClipped = ref(false);
  const textClipped = ref(false);
  const clippedAmount = ref(0);

  function setTextClipped() {
    const textElementEndPosition = textElement.value.getBoundingClientRect().right;
    const subheadElementEndPosition = subheadElement.value.getBoundingClientRect().right;
    const endPositionDelta = subheadElementEndPosition - textElementEndPosition;

    textClipped.value = endPositionDelta < 0;
    clippedAmount.value = textClipped.value ? endPositionDelta - 16 : 0;
  }

  function handleShowClipped() {
    if (!textClipped.value) return;

    showClipped.value = true;

    setTimeout(() => showClipped.value = false, 4000);
  }

  onMounted(() => {
    if (!textElement.value) return;

    setTextClipped();
  });

  useResizeObserver(textElement, () => {
    if (!textElement.value) return;

    setTextClipped();
  });
</script>

<template>
  <div
    ref="subhead-element"
    class="jwx-toolbar-header__subheader"
    :class="{ 'jwx-toolbar-header__subheader--no-icon': !props.icon }"
    :data-is-clipped="textClipped"
  >
    <Icon v-if="props.icon" :name="props.icon" class="jwx-toolbar-header__subheader-icon" />
    <p
      ref="text-element"
      @click="handleShowClipped"
      class="jwx-toolbar-header__subheader-text"
      :class="{ 'show-clipped' : showClipped }"
      :style="`--clipped-amount: ${clippedAmount}px`"
    >
      {{ props.text }}
    </p>
  </div>
</template>
